import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectDBNCategoryAccountMappingsListItems } from "../../../../../../redux/dbn-category-account-mappings/selector";
import { dbnCategoryAccountMappings } from "../../../../../../redux/dbn-category-account-mappings/action";

interface AccountMappingProps {
  accountId?: number,
  id?: number,
  filters?: any
}

const DBNCategoryAccountMappings = ({ accountId, id, filters }: AccountMappingProps) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSerchCriteriaList] = useState<any>([]);
  const dbnCategoryAccountMappingsListData = useSelector(selectDBNCategoryAccountMappingsListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AccountName', headerName: 'Account Name', searchField: 'AccountName', sortable: true, filter: true, filterType: 'text' },
      { field: 'EdgeDBNCategoryName', headerName: 'Edge DBN Category Name', searchField: 'EdgeDBNCategoryName', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const fetchDBNCategoryAccountMappingsList = () => {
    dispatch(dbnCategoryAccountMappings.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-category_account-mappings/fetch`,
      entity: 'dbnCategoryAccountMappings',
      jsonData:
      {
        Context: {},
        Records: [
          {
            EdgeDBNCategoryId: id? id : undefined,
            AccountId: accountId ? accountId : undefined
          }
        ],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "CreatedOnUtc",
          SortOrder: "desc",
          Searches: searchCriteriaList || undefined,
          Filters: filters || undefined
        }
      }
    }))
  }

  const handleReloadData = () => {
    fetchDBNCategoryAccountMappingsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "EdgeDBNCategoryName",
        FieldText: "EdgeDBNCategoryName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSerchCriteriaList(searchCriteria)
    fetchDBNCategoryAccountMappingsList
  }

  useEffect(() => {
    createColumnDefs();
    fetchDBNCategoryAccountMappingsList();
  }, [pageData, pageSize, searchCriteriaList])

  return (
    <>
      {dbnCategoryAccountMappingsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} 
          rowData={dbnCategoryAccountMappingsListData?.result?.items}
          setPageData={setPageData} 
          setPageSize={setPageSize} 
          searchCriteriaList={searchCriteriaList}
          paginationData={dbnCategoryAccountMappingsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'EdgeDBNCategoryId',
          }}
          additionButtons={additionButtons}
          headingName="Category Account Mappings"
        />
      }
    </>
  );
};

export default DBNCategoryAccountMappings;


